export default __webpack_public_path__ + "static/media/lesnik_winter_b_05.7af25f53.svg";